import {AccountWithTosContext, hasAdminAccess, hasOwnerAccess, isAdminAccount} from "../../util/AccountUtils";

class AccountUtilService {
    static userNeedsTosConfirmation = (user?: AccountWithTosContext | null) => {

        return user
            && !isAdminAccount(user)
            && !hasAdminAccess(user)
            && hasOwnerAccess(user)
            && !user.hasAcceptedCurrentTos
    }
}

export default AccountUtilService
